<template>
    <div>
        <AppHeader />
        <div>
            <h2 class="text-center mt-4 mb-4">Lista de vistorias</h2>
            <h4 class="text-center mt-5" v-if="inspections.length === 0">
                Nenhuma vistoria realizada!
            </h4>
            <div v-else>
                <div class="description float-left">
                    <div class="itemDescription">
                        <span class="colorGreen"></span>
                        <p class="textDescription">Enviadas</p>
                    </div>
                    <div class="itemDescription">
                        <span class="colorYellow"></span>
                        <p class="textDescription">Não enviadas</p>
                    </div>
                </div>
                <b-button
                    class="float-right"
                    type="button"
                    variant="secondary"
                    @click="exportarBanco"
                >
                    Exportar dados <br> (para suporte)
                </b-button>
                <b-table
                    class="mt-3"
                    head-variant="light"
                    sticky-header
                    striped
                    responsive
                    hover
                    :items="inspections"
                    :fields="fields"
                    :class="{ pendente: inspections.index }"
                >
                    <template #cell(PDF)="data">
                        <PDFButton :id-vistoria="data.item.idVistoria"></PDFButton>
                        <a :href="`${data.value}`" v-if="`${data.value}`" target="_blank">Abrir</a>
                    </template>

                    <template #cell(fotos)="{ item }">
                        <b-button variant="primary" size="sm" @click="telaImagens(item)"
                        >Acessar</b-button
                        >
                    </template>
                </b-table>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/Header.vue";
import PDFButton from "@/components/PDFButton.vue";
import Database from "@/controller/database";
import exportarBanco from "@/utils/exportarBanco";

import { BButton, BTable } from "bootstrap-vue";

export default {
    components: {
        AppHeader: Header,
        BTable,
        BButton,
        PDFButton
    },
    methods: {
        telaImagens(item) {
            return this.$router.push({ path: "imagens", query: { id: item.id } });
        },
        exportarBanco
    },
    data: function () {
        return {
            inspections: [],
            fields: [
                {
                    key: "id",
                    label: "ID",
                    sortable: true,
                },

                {
                    key: "placa",
                },

                {
                    key: "questionario",
                    label: "Questionário",
                },

                {
                    key: "tipoDeOperacao",
                    label: "Tipo de Operação",
                },

                {
                    key: "data",
                },

                {
                    key: "hora",
                },

                {
                    key: "status",
                },

                {
                    key: "token",
                },
                {
                    key: "PDF",
                },
                {
                    key: "fotos",
                },
            ],
        };
    },
    created: async function () {
        const database = new Database();

        let inspections;
        await database
            .createOrOpenDatabase({ listInspection: true })
            .then((response) => (inspections = response))
            .catch(() => (inspections = []));

        let enterprise = JSON.parse(localStorage.getItem("enterprise"));

        for (let i = 0; i < inspections.length; i++) {
            let inspection = inspections[i];

            // Coloca cor na linha
            if (inspection.status == "Pendente") {
                inspection._rowVariant = "warning";
            } else if (inspection.status == "Enviado") {
                inspection._rowVariant = "success";
            }
            
            // Remove ID da vistoria da tabela da lista de vistorias.
            // delete inspections[i].idVistoria;
            // Remove da lista de vistorias se ela não for do token atual logado (ela continua salva no indexeddb)
            for (let j = 0; j < inspections.length; j++) {
                if (inspections[j].token != enterprise.name) {
                    inspections.splice(j, 1);
                    i--;
                }
            }
        }
        this.inspections = inspections;
    },
};
</script>

<style scoped>
span {
    width: 19px;
    height: 19px;
    border-radius: 50%;
    display: inline-block;
}

.colorGreen {
    border: 1px solid gray;
    background-color: #c3e6cb;
}

.description {
    box-sizing: border-box;
    border: 2px solid gray;
    padding: 4px;
    margin: 3px;
    border-radius: 10px;
    width: fit-content;
    height: fit-content;
}

.textDescription {
    margin: 0;
    margin-left: 2px;
}

.itemDescription {
    display: flex;
    margin: 1px;
}

.colorYellow {
    border: 1px solid gray;
    background-color: #ffeeba;
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #343a40;
    height: 60px;
}

.header img,
.header .dropdown {
    margin: 10px;
}

.header img,
.header .dropdown {
    margin: 10px;
}
</style>
